<template>
  <div class="fengkongtu-page">
    <div class="container">
      <!-- 头部 -->
      <div class="header">
        <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" @click="goBack">
          <path d="M778.671 926.323a56.811 56.811 0 1 1-80.33 80.331L243.85 552.165a56.811 56.811 0 0 1 0-80.33l454.49-454.49a56.811 56.811 0 1 1 80.33 80.331L364.348 512 778.67 926.323z"></path>
        </svg>
        <div class="header-title">风控图</div>
      </div>

      <!-- 平台选择器 -->
      <div class="platform-selector">
        <div class="platform-item" @click="selectPlatform('ysf')">云闪付</div>
        <div class="platform-item" @click="selectPlatform('wx')">微信</div>
        <div class="platform-slider" :class="{ wx: currentPlatform === 'wx' }"></div>
      </div>

      <!-- 表单区域 -->
      <div class="form-section">
        <!-- 云闪付表单 -->
        <div v-show="currentPlatform === 'ysf'" class="ysf-form">
          <div class="form-item">
            <label>姓名</label>
            <input type="text" v-model="ysfForm.name">
          </div>
          <div class="form-item">
            <label>卡号</label>
            <input type="text" v-model="ysfForm.card">
          </div>
          <div class="form-item">
            <label>转账金额</label>
            <input type="text" v-model="ysfForm.amount">
          </div>
          <div class="form-item">
            <label>原因</label>
            <input type="text" v-model="ysfForm.reason">
          </div>
          <div class="form-item">
            <label>可用余额</label>
            <input type="text" v-model="ysfForm.balance">
          </div>
          <div class="form-item">
            <label>付款卡</label>
            <input type="text" v-model="ysfForm.paymentCard">
          </div>
          <div class="form-item">
            <label>开启弹窗</label>
            <div 
              class="toggle-switch" 
              :class="{ active: ysfPopupEnabled }" 
              @click="ysfPopupEnabled = !ysfPopupEnabled"
            ></div>
          </div>
        </div>

        <!-- 微信表单 -->
        <div v-show="currentPlatform === 'wx'" class="wx-form">
          <div class="form-item">
            <label>微信昵称</label>
            <input type="text" v-model="wxForm.nickname">
          </div>
          <div class="form-item">
            <label>真名尾字</label>
            <input type="text" v-model="wxForm.lastname">
          </div>
          <div class="form-item">
            <label>转账金额</label>
            <input type="text" v-model="wxForm.amount">
          </div>
          <div class="form-item">
            <label>风控原因</label>
            <input type="text" v-model="wxForm.reason">
          </div>
          <div class="form-item">
            <label>按钮文本</label>
            <input type="text" v-model="wxForm.btnText">
          </div>
        </div>
      </div>

      <!-- 预览区域 -->
      <div class="preview-section">
        <!-- 云闪付预览 -->
        <div v-show="currentPlatform === 'ysf'" class="preview-content ysf">
          <div class="ysf-header">
            <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20">
              <path d="M369.728 512l384.768-384.704a48.64 48.64 0 0 0 0.896-68.8 48.64 48.64 0 0 0-68.736 0.96L269.44 476.736a48.704 48.704 0 0 0-11.136 17.344c-1.024 2.304-1.024 4.736-1.472 7.04-0.896 3.648-2.048 7.168-2.048 10.88 0 3.712 1.152 7.232 1.984 10.88 0.512 2.368 0.512 4.8 1.472 7.04a48.704 48.704 0 0 0 11.136 17.344l417.216 417.28a48.576 48.576 0 0 0 68.736 0.96 48.576 48.576 0 0 0-0.896-68.736L369.728 512z" fill="#030000"></path>
            </svg>
            <div>转到银行卡</div>
          </div>

          <div class="ysf-card ysf-info-list">
            <div class="ysf-info-item">
              <div class="ysf-info-label">收款户名</div>
              <div class="ysf-info-value">{{ ysfForm.name }}</div>
            </div>
            <div class="ysf-info-item">
              <div class="ysf-info-label">收款卡号</div>
              <div class="ysf-info-value">{{ ysfForm.card }}</div>
            </div>
          </div>

          <div class="ysf-card ysf-amount-section">
            <div class="ysf-amount-title">转账金额</div>
            <div class="ysf-amount-display">
              <span>￥</span>
              <b>{{ ysfForm.amount }}</b>
            </div>
            <div class="ysf-payment-card">
              <div class="ysf-payment-label">付款卡</div>
              <div class="ysf-payment-details">
                <div class="ysf-payment-bank">
                  <span>{{ ysfForm.paymentCard }}</span>
                  <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="10" height="10">
                    <path d="M236.552013 926.853955a55.805997 55.805997 0 0 0 0 80.454996 59.682997 59.682997 0 0 0 82.794996 0l468.099978-455.081978a55.805997 55.805997 0 0 0 0-80.453996L319.348009 16.689999a59.682997 59.682997 0 0 0-82.794996 0 55.805997 55.805997 0 0 0 0 80.454996L663.401993 511.999975 236.624013 926.853955z" fill="#707070"></path>
                  </svg>
                </div>
                <div class="ysf-payment-notice">
                  <div>单笔5万，其中山西、甘肃区域单笔1万</div>
                </div>
                <div class="ysf-payment-balance">
                  <div>可用余额：￥<span>{{ ysfForm.balance }}</span></div>
                  <div class="ysf-transfer-all">全部转出</div>
                </div>
              </div>
            </div>
          </div>

          <div class="ysf-confirm-btn">
            <div>确认转账</div>
          </div>

          <div class="ysf-tips">
            <p>温馨提示</p>
            <p>1.以<span>投资理财、贷款审批、快递理赔、会员退订、网购刷单、信用卡提额、变更学生账户、注销账户、对接安全认证归还教育额度</span>为由的转账均为<span>诈骗</span>，不要轻易向<span>陌生人</span>转账，日转出无法追回。</p>
            <p>2.响应国家号召，及时下载"<span>国家反诈中心</span>"APP,完成实名认证并开启来电预警功能。全国携手、全力防范电信诈骗。</p>
            <p>3.您所填写的收款姓名、收款卡号将用于供您本次交易发起、回顾交易记录以及后续转账使用。</p>
          </div>

          <!-- 云闪付弹窗 -->
          <div v-show="ysfPopupEnabled" class="popup-overlay" @click="ysfPopupEnabled = false"></div>
          <div v-show="ysfPopupEnabled" class="popup">
            <div class="popup-message">{{ ysfForm.reason }}</div>
            <div class="popup-buttons">
              <div class="popup-button cancel">取消交易</div>
              <div class="popup-button confirm">申请解除</div>
            </div>
          </div>
        </div>

        <!-- 微信预览 -->
        <div v-show="currentPlatform === 'wx'" class="preview-content wx">
          <div class="wx-cover"></div>

          <div class="wx-header">
            <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="18" height="18">
              <path d="M277.382 553.022c-23.136-22.633-23.113-59.378 0.024-82.035l383.961-421.98c23.16-22.657 60.65-22.68 83.786-0.048 23.112 22.657 23.088 59.378-0.048 82.058l-347.407 381.779 346.713 381.035c23.16 22.681 23.401 59.186 0.576 81.555-22.825 22.368-60.122 22.104-83.258-0.553l-383.052-420.97c-0.382-0.361-0.91-0.457-1.294-0.84z" fill="#2c2c2c"></path>
            </svg>
            <div class="wx-header-title">企业专用打款</div>
          </div>

          <div class="wx-recipient">
            <div class="wx-recipient-title">打款给个人</div>
            <div class="wx-recipient-name">{{ wxRecipientDisplay }}</div>
          </div>

          <div class="wx-amount-section">
            <div class="wx-amount-title">付款金额</div>
            <div class="wx-amount-display" style="margin-top: 0px; padding-top: 0px; border-top-style: solid; border-top-width: 0px; margin-bottom: 0px;">
              <div class="wx-amount-symbol" style="padding-left: 0px; margin-left: -10px;">￥</div>
              <div class="wx-amount-value">{{ wxForm.amount }}</div>
            </div>
            <div class="wx-divider"></div>
          </div>

          <!-- 微信弹窗 -->
          <div class="popup-overlay wx"></div>
          <div class="popup wx" style="margin-top: -6px;">
            <div class="popup-message wx">{{ wxForm.reason }}</div>
            <div class="popup-buttons wx">
              <div class="popup-button wx">取消</div>
              <div class="popup-button wx">{{ wxForm.btnText }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, computed } from 'vue'

export default {
  name: 'FengkongtuPage',
  emits: ['close'],
  setup(props, { emit }) {
    // 当前平台
    const currentPlatform = ref('ysf')

    // 云闪付弹窗开关
    const ysfPopupEnabled = ref(true)

    // 云闪付表单数据
    const ysfForm = reactive({
      name: '伟哥',
      card: '222',
      amount: '111',
      reason: '该卡收到交易限制，无法转账',
      balance: '32945.74',
      paymentCard: '工商银行[9246]'
    })

    // 微信表单数据
    const wxForm = reactive({
      nickname: '牛逼',
      lastname: '龙',
      amount: '789',
      reason: '当前交易异常，为保障资金安全，打款暂时无法完成',
      btnText: '确定'
    })

    // 微信收款人显示
    const wxRecipientDisplay = computed(() => {
      return `${wxForm.nickname}（**${wxForm.lastname}）`
    })

    // 平台切换
    const selectPlatform = (platform) => {
      currentPlatform.value = platform
    }

    // 返回
    const goBack = () => {
      emit('close')
    }

    return {
      currentPlatform,
      ysfPopupEnabled,
      ysfForm,
      wxForm,
      wxRecipientDisplay,
      selectPlatform,
      goBack
    }
  }
}
</script>

<style scoped>
.fengkongtu-page {
  background-color: #f5f5f5;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.container {
  height: 100%;
  width: 100%;
  background-color: #fff;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  position: relative;
}

/* 头部 */
.header {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background-color: #fff;
  border-bottom: 1px solid #eee;
}

.header svg {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.header-title {
  margin-left: 12px;
  font-weight: bold;
}

/* 平台选择器 */
.platform-selector {
  display: flex;
  background-color: #dbdbdb;
  position: relative;
  box-sizing: border-box;
  font-size: 0.9rem;
  flex-wrap: wrap;
  border: 2px solid #dbdbdb;
  margin: 10px;
  border-radius: 6px;
}

.platform-item {
  flex: 1;
  text-align: center;
  min-height: 36px;
  max-height: 36px;
  line-height: 36px;
  z-index: 2;
  color: #555555;
  min-width: 50%;
  max-width: 50%;
  cursor: pointer;
}

.platform-slider {
  content: "";
  width: 50%;
  min-height: 36px;
  max-height: 36px;
  background-color: #f5f5f5;
  position: absolute;
  left: 0;
  transition: transform 0.2s linear;
  border-radius: 4px;
}

.platform-slider.wx {
  transform: translateX(100%);
}

/* 表单区域 */
.form-section {
  padding: 0 16px;
}

.form-item {
  display: flex;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #eee;
}

.form-item label {
  min-width: 80px;
  color: #707070;
}

.form-item input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 1rem;
  padding: 4px 0;
}

.toggle-switch {
  width: 50px;
  height: 26px;
  background-color: #e0e0e0;
  border-radius: 13px;
  position: relative;
  cursor: pointer;
  transition: background-color 0.3s;
}

.toggle-switch.active {
  background-color: #4CAF50;
}

.toggle-switch::after {
  content: "";
  position: absolute;
  width: 22px;
  height: 22px;
  background-color: white;
  border-radius: 50%;
  top: 2px;
  left: 2px;
  transition: transform 0.3s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.toggle-switch.active::after {
  transform: translateX(24px);
}

/* 预览区域 */
.preview-section {
  margin-top: 20px;
  position: relative;
}

.preview-content {
  min-height: 100vh;
  position: relative;
  overflow: hidden;
}

.preview-content.ysf {
  background-color: #f5f5f5;
}

.preview-content.wx {
  background-color: #ededed;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

/* 云闪付样式 */
.ysf-header {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 1.1rem;
  height: 44px;
  background-color: #fff;
}

.ysf-header svg {
  position: absolute;
  left: 18px;
}

.ysf-card {
  padding: 18px;
  background-color: #fff;
  margin: 0 16px;
  border-radius: 12px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.05);
  margin-top: 10px;
}

.ysf-info-list {
  display: flex;
  flex-direction: column;
  margin-top: 12px;
  padding-top: 0;
  padding-bottom: 0;
}

.ysf-info-item {
  padding: 18px 0;
  display: flex;
  align-items: baseline;
}

.ysf-info-item + .ysf-info-item {
  border-top: 0.5px solid #dbdbdb;
}

.ysf-info-label {
  min-width: 6rem;
  color: #707070;
}

.ysf-info-value {
  font-size: 0.92rem;
}

.ysf-amount-section {
  margin-top: 20px;
}

.ysf-amount-title {
  font-weight: bold;
  margin-bottom: 24px;
}

.ysf-amount-display {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  display: flex;
  align-items: center;
  gap: 4px;
  padding-bottom: 6px;
  border-bottom: 1px solid #dbdbdb;
  margin-bottom: 18px;
}

.ysf-amount-display span {
  font-size: 1.35rem;
  margin-top: 4px;
}

.ysf-amount-display b {
  font-size: 2.2rem;
  font-weight: normal;
  letter-spacing: 1px;
}

.ysf-payment-card {
  display: flex;
  align-items: flex-start;
}

.ysf-payment-label {
  min-width: 6rem;
  color: #707070;
  line-height: 20px;
}

.ysf-payment-details {
  display: flex;
  flex-direction: column;
}

.ysf-payment-bank {
  margin-bottom: 8px;
  font-size: 0.9rem;
  line-height: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding-right: 12px;
}

.ysf-payment-notice {
  color: #707070;
  font-size: 0.88rem;
  margin-bottom: 4px;
}

.ysf-payment-balance {
  font-size: 0.88rem;
  color: #707070;
  display: flex;
  align-items: center;
}

.ysf-transfer-all {
  color: #4a7cff;
  margin-left: 6px;
  font-size: 0.88rem;
  word-break: keep-all;
}

.ysf-confirm-btn {
  background-color: #e81d23;
  color: #fff;
  margin: 0 16px;
  margin-top: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px 0;
  border-radius: 32px;
  cursor: pointer;
}

.ysf-tips {
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 0.75rem;
  margin: 0 16px;
  margin-top: 36px;
  color: #999;
}

.ysf-tips span {
  color: #e81d23;
  font-weight: bold;
}

/* 微信样式 */
.wx-cover {
  height: 100%;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  object-fit: cover;
  overflow: hidden;
  opacity: 0.4;
}

.wx-cover img {
  width: 100%;
  transform: translateY(-48px);
  object-fit: cover;
}

.wx-header {
  padding: 1.4vh 0;
  box-sizing: border-box;
  padding-left: 3vw;
  position: relative;
  display: flex;
  align-items: center;
}

.wx-header-title {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 1.09rem;
  font-weight: bold;
}

.wx-recipient {
  box-sizing: border-box;
  padding-left: 7.96vw;
  padding-top: 3vh;
  padding-bottom: 3.33vh;
  display: flex;
  flex-direction: column;
  gap: 0.4vh;
}

.wx-recipient-title {
  font-weight: bold;
  color: #000;
  font-size: 1.045rem;
}

.wx-recipient-name {
  font-size: 0.74rem;
  color: #7c7c7c;
}

.wx-amount-section {
  background-color: #fff;
  border-radius: 14px 14px 0 0;
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-top: 10px;
  padding-bottom: 20px;
}

.wx-amount-title {
  font-weight: bold;
  font-size: 0.854rem;
  width: 100%;
  box-sizing: border-box;
  padding-left: 7.94vw;
  padding-top: 3.84vh;
  color: #424242;
}

.wx-amount-display {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  margin-top: 1.046rem;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #000;
  margin-left: 7.78vw;
}

.wx-amount-symbol {
  font-size: 2.3rem;
  transform: translate(0, -0.365rem);
}

.wx-amount-value {
  font-size: 3.25rem;
}

.wx-divider {
  height: 1px;
  width: auto;
  margin-left: 7.6vw;
  margin-right: 7.6vw;
  background-color: #f6f6f6;
  margin-top: 1.08vh;
}

/* 弹窗 */
.popup-overlay {
  height: 100%;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.15);
}

.popup-overlay.wx {
  background-color: rgba(0, 0, 0, 0.3);
}

.popup {
  z-index: 11;
  position: absolute;
  background-color: #fff;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.01);
  width: 80%;
  max-width: 300px;
}

.popup.wx {
  border-radius: 8px;
}

.popup-message {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 18px;
  word-break: break-all;
  box-sizing: border-box;
  border-bottom: 0.5px solid #c2c2c2;
  text-align: center;
}

.popup-message.wx {
  padding: 2.05rem 2rem;
  font-size: 1.043rem;
  font-weight: bold;
  text-align: center;
  line-height: 1.38rem;
  word-break: break-all;
  border-bottom: none;
}

.popup-buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-size: 0.95rem;
}

.popup-buttons.wx {
  display: flex;
  border-top: 0.5px solid #ededed;
  gap: 0.5px;
  background-color: #ededed;
  font-size: 1.05rem;
  box-sizing: border-box;
}

.popup-button {
  flex: 1;
  text-align: center;
  padding: 16px;
  cursor: pointer;
}

.popup-button.wx {
  flex: 1;
  text-align: center;
  background-color: #fff;
  padding: 1rem 0;
  box-sizing: border-box;
}

.popup-button.wx:first-child {
  padding-left: 0.5rem;
}

.popup-button.wx:last-child {
  padding-right: 0.5rem;
  color: #4f689e;
}

.popup-button.cancel {
  color: #6a6a6a;
}

.popup-button.confirm {
  color: #e81d23;
  border-left: 0.5px solid #c2c2c2;
}
</style>
